import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import About from './Components/About/About'
import Cta from './Components/Cta/Cta'
import Explore from './Components/Explore/Explore'
import Faq from './Components/Faq/Faq'
import Features from './Components/Features/Features'
import Hero from './Components/Hero/Hero'

function Datasets({ copy }) {
  return (
    <div className="datasets">
      <Hero hero={copy.hero} />
      <About about={copy.about} />
      <Features features={copy.features} />
      <Explore explore={copy.explore} />
      <Cta cta={copy.cta} form={copy.form} />
      <Faq faq={copy.faq} />
    </div>
  )
}

Datasets.propTypes = {
  copy: shape({
    hero: shape({ title: string.isRequired }).isRequired,
    about: shape({ title: string.isRequired }).isRequired,
    features: shape({ title: string.isRequired }).isRequired,
    explore: shape({ title: string.isRequired }).isRequired,
    cta: shape({ title: string.isRequired }).isRequired,
    form: shape({ submit: string.isRequired }).isRequired,
    faq: shape({ items: arrayOf(shape({ question: string.isRequired })).isRequired }).isRequired,
  }).isRequired,
}

export default Datasets
